import axios from "axios";
import React, { useState, useEffect } from "react";
import { BiEditAlt, BiTrash } from "react-icons/bi";
import { MdOutlineCancel, MdSave } from "react-icons/md";
import { token } from "../../API";
import EditTagStyles from "./EditTagWr";

// toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditTag = ({ data, successCallback }) => {
  // getting
  const [texts, setTexts] = useState({});
  useEffect(() => {
    setTexts({
      textUz: data.textUz,
      textRu: data.textRu,
      textEn: data.textEn,
    });
  }, [data]);
  const [active, setActive] = useState("textUz");
  const menus = [{ t: "textUz" }, { t: "textEn" }, { t: "textRu" }];

  // editing
  const [textBool, setTextBool] = useState("d-block");
  const [inputBool, setInputBool] = useState("d-none");
  const [input, setInput] = useState("");

  // delete
  const [tagBool, setTagBool] = useState("d-block");
  const viewHandle = (v) => {
    if (v === "d-block") {
      setTextBool("d-none");
      setInputBool("d-block");
    } else {
      setTextBool("d-block");
      setInputBool("d-none");
    }
    setInput(texts[active]);
  };
  // save
  const saveHandle = () => {
    let oldVals = texts;
    oldVals[active] = input;
    setTexts(oldVals);
    viewHandle("d-none");
    setTag(oldVals, false);
  };
  // delete
  const deleteHandler = () => {
    let conf = confirm(`Haqiqatdan ham ${data.textUz}ni o'chirmoqchimisiz?`);
    if (conf) {
      setTag(data.id, true);
      setTagBool("d-none");
    }
  };

  const setTag = async (body, remove) => {
    const url = `http://164.90.236.174:1988/koinot/tag/${
      remove ? data.id : ""
    }`;
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };
    try {
      if (remove) {
        let res = await axios.delete(url, headers);
        successCallback(`${data.textUz} teg o'chirildi!`, "s");
        return res;
      } else {
        let res = await axios.post(url, body, headers);
        successCallback(`${data.textUz} teg o'zgartirildi!`, "s");
        return res;
      }
    } catch (error) {
      console.error(error);
      successCallback(
        "Tegni o'zgartirishda xatolik, internetga ulanganlikni tekshiring yoki logout qilib qayta kiring",
        "e"
      );
      return { error: true, error };
    }
  };

  return (
    <EditTagStyles className={tagBool}>
      <div className="row my-3">
        {/* tilni almashtirish */}
        <div className="col-3 border p-2 d-flex">
          {menus.map((v, i) => (
            <button
              key={i}
              onClick={() => {
                setActive(v.t);
                setInput(texts[v.t]);
              }}
              className={`btn col-4 ${
                active === v.t ? "btn-success" : "btn-outline-success"
              }`}
            >
              {v.t}
            </button>
          ))}
        </div>
        {/* tilni almashtirish */}
        {/* text va input */}
        <div className="col-6 border p-2">
          <p className={`font-monospace ${textBool}`}>{texts[active]}</p>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              saveHandle();
            }}
            className={`form-group w-100 d-flex ${inputBool}`}
          >
            <textarea
              className="form-control"
              id=""
              value={input}
              onChange={(e) => setInput(e.target.value)}
              rows="1"
            ></textarea>
          </form>
        </div>
        {/* text va input */}
        {/* edit, cancel, save, delete*/}
        <div className="col-3 border p-2 d-flex">
          <span className={`${textBool} w-100`}>
            <button
              className="btn btn-info col-6"
              onClick={() => viewHandle("d-block")}
            >
              <BiEditAlt className="text-primary" />
            </button>
            <button
              className="btn btn-danger col-6"
              onClick={() => deleteHandler()}
            >
              <BiTrash color="white" />
            </button>
          </span>

          <span className={`${inputBool} w-100`}>
            <button
              className="btn btn-warning col-6"
              onClick={() => viewHandle("d-none")}
            >
              <MdOutlineCancel className="text-danger" />
            </button>
            <button
              onClick={() => saveHandle()}
              className="btn btn-success  col-6"
            >
              <MdSave className="text-white" />
            </button>
          </span>
        </div>
        {/* edit, cancel, save, delete*/}
      </div>
      {/* toast */}
      <div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </EditTagStyles>
  );
};

export default EditTag;



// WEBPACK FOOTER //
// ./src/Components/EditTag/index.js